// Product card for home-* sections (snippets/home-product-card.liquid)
// Color swatches swap images, price, installments, badges and link; arrows and hover browse the color's images

const HPC_WIDTHS = [300, 450, 600, 900]
const HPC_FADE_MS = 450

class HomeProductCard extends HTMLElement {
	connectedCallback() {
		let dataEl = this.querySelector("[data-hpc-data]")
		this.colors = JSON.parse(dataEl?.textContent || "[]")
		this.slot = Number(this.dataset.selected) || 0
		this.index = 0

		this.media = this.querySelector(".hpc__media")
		this.link = this.querySelector("[data-hpc-link]")
		this.price = this.querySelector("[data-hpc-price]")
		this.compare = this.querySelector("[data-hpc-compare]")
		this.installments = this.querySelector("[data-hpc-installments]")
		this.prevBtn = this.querySelector('[data-hpc-nav="-1"]')
		this.nextBtn = this.querySelector('[data-hpc-nav="1"]')

		let firstImg = this.querySelector("[data-hpc-img]")
		this.sizes = firstImg?.getAttribute("sizes") || "300px"
		this.imgs = firstImg ? [firstImg] : []

		this.querySelectorAll("[data-hpc-swatch]").forEach(swatch => {
			swatch.addEventListener("click", () => this.selectColor(Number(swatch.dataset.hpcSwatch)))
		})
		this.prevBtn?.addEventListener("click", () => this.show(this.index - 1))
		this.nextBtn?.addEventListener("click", () => this.show(this.index + 1))

		if (window.matchMedia("(hover: hover)").matches) {
			this.addEventListener("mouseenter", () => {
				if (this.index === 0 && this.images().length > 1) this.show(1)
			})
			this.addEventListener("mouseleave", () => this.show(0))
		}

		this.updateNav()
	}

	images() {
		return this.colors[this.slot]?.images ?? []
	}

	srcset(url) {
		return HPC_WIDTHS.map(width => {
			let u = new URL(url, window.location.href)
			u.searchParams.set("width", width)
			return `${u.href} ${width}w`
		}).join(", ")
	}

	createImg(url) {
		let img = document.createElement("img")
		img.className = "hpc__img"
		img.alt = ""
		img.decoding = "async"
		img.sizes = this.sizes
		img.srcset = this.srcset(url)
		img.src = url
		this.media.insertBefore(img, this.media.querySelector(".hpc__badges"))
		return img
	}

	show(target) {
		let images = this.images()
		if (images.length === 0) return

		let next = Math.max(0, Math.min(target, images.length - 1))
		this.imgs[next] ??= this.createImg(images[next])
		this.imgs.forEach((img, i) => img?.classList.toggle("is-active", i === next))
		this.index = next
		this.updateNav()
	}

	updateNav() {
		let count = this.images().length
		let hasMany = count > 1

		if (this.prevBtn) {
			this.prevBtn.hidden = !hasMany
			this.prevBtn.disabled = this.index === 0
		}
		if (this.nextBtn) {
			this.nextBtn.hidden = !hasMany
			this.nextBtn.disabled = this.index >= count - 1
		}

		// Half-width bar like the prototype: left on the first image, right on the last one
		this.style.setProperty("--hpc-bar-progress", count > 1 ? this.index / (count - 1) : 0)
	}

	selectColor(slot) {
		let color = this.colors[slot]
		if (!color || slot === this.slot) return

		this.querySelectorAll("[data-hpc-swatch]").forEach(swatch => {
			swatch.setAttribute("aria-pressed", String(Number(swatch.dataset.hpcSwatch) === slot))
		})
		this.querySelectorAll("[data-hpc-badges]").forEach(group => {
			group.hidden = Number(group.dataset.hpcBadges) !== slot
		})

		if (this.link) this.link.href = color.url
		if (this.price) {
			this.price.textContent = color.price
			this.price.classList.toggle("is-sale", color.sale)
		}
		if (this.compare) this.compare.textContent = color.compare
		if (this.installments) this.installments.innerHTML = color.installments

		this.swapImages(color.images)
		this.slot = slot
		this.index = 0
		this.updateNav()
	}

	// Crossfade to the new color's first image once it has loaded
	swapImages(images) {
		let old = this.imgs.filter(Boolean)
		this.imgs = []
		if (images.length === 0) return

		let img = this.createImg(images[0])
		this.imgs[0] = img

		let reveal = () => {
			img.classList.add("is-active")
			old.forEach(o => o.classList.remove("is-active"))
			setTimeout(() => old.forEach(o => o.remove()), HPC_FADE_MS)
		}

		if (img.complete) reveal()
		else {
			img.addEventListener("load", reveal, { once: true })
			img.addEventListener("error", reveal, { once: true })
		}
	}
}

if (!customElements.get("home-product-card")) customElements.define("home-product-card", HomeProductCard)
